import React from 'react';
//import PropTypes from 'prop-types';
import * as S from './LocalizationLinkedList.styled';
import MenuItem from '../menuItem/MenuItem';

const LocalizationLinkedList = ({ data, show }) => {
  const watchIsActive = (name) => {
    name = name.replace(' ', '-');
    const path = window.location.href;
    const regex = new RegExp(name, 'i');
    return !!path.match(regex);
  };

  return (
    <S.LocalizationList show={show}>
      <S.Container>
        {data.map((item) => (
          <MenuItem
            key={item.id}
            text={item.name}
            url={item.link}
            isActive={watchIsActive(item.id)}
            disabled={item.disabled}
          />
        ))}
      </S.Container>
    </S.LocalizationList>
  );
};

export default LocalizationLinkedList;
